<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.19995 4.99995C3.19995 4.55812 3.55812 4.19995 3.99995 4.19995H20C20.4418 4.19995 20.7999 4.55812 20.7999 4.99995C20.7999 5.44178 20.4418 5.79995 20 5.79995H3.99995C3.55812 5.79995 3.19995 5.44178 3.19995 4.99995Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.19995 12C3.19995 11.5581 3.55812 11.2 3.99995 11.2L20 11.2C20.4418 11.2 20.7999 11.5581 20.7999 12C20.7999 12.4418 20.4418 12.8 20 12.8L3.99995 12.8C3.55812 12.8 3.19995 12.4418 3.19995 12Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.19995 19C3.19995 18.5581 3.55812 18.2 3.99995 18.2L20 18.2C20.4418 18.2 20.7999 18.5581 20.7999 19C20.7999 19.4418 20.4418 19.8 20 19.8L3.99995 19.8C3.55812 19.8 3.19995 19.4418 3.19995 19Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
